import React from "react";
import "../Styles/Contact.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faSquareGithub } from "@fortawesome/free-brands-svg-icons";

function Contact() {
  return (
    <div className="Contact">
      <div className="title">Get in Touch</div>
      <p>Use the form below to send me a message.</p>
      <form action="https://formspree.io/xoqpapnd" method="POST">
        <p>All fields are required.</p>
        <fieldset>
            <p>
            <label for="name">Name</label>
            <input name="user_name" type="text" id="name" required />
            </p>
            <p>
            <label for="email" aria-label="required"> E-mail</label>
            <input name="user_email" type="email" id="email" required />
            </p>
        </fieldset>
        <p className="message">
          <label for="message">Message</label>
          <textarea name="user_message" id="message" required>
            
          </textarea>
        </p>

        <p class="button">
          <button type="submit">Send</button>
        </p>
      <div className="social-links">
        <div>
        <a href="https://github.com/r-shahid/">
              <FontAwesomeIcon icon={faSquareGithub} />
            </a>
        </div>
        <div>
        <a href="https://www.linkedin.com/in/rianashahid/">
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
        </div>
        {/* <div>
          Twitter
        </div> */}
      </div>
      </form>
    </div>
  );
}

export default Contact;